<ion-header class="ion-no-border" [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button color="primary" (click)="closeModal()">Close</ion-button>
    </ion-buttons>
    <ion-title>Add Card</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <form [formGroup]="paymentForm" (ngSubmit)="processPayment()">
    <div #cardElement class="stripe-element"></div>
    <div id="card-errors" role="alert"></div>
    <ion-button color="success" expand="block" type="submit" [disabled]="approve">Add Card</ion-button>
  </form>
</ion-content>
